// src/components/Navbar/Navbar.js
import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Database, Settings } from 'lucide-react';
import './Navbar.css';

const Navbar = ({ currentUser, onLogout }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, path: '/dashboard' },
    { id: 'mydata', label: 'My Data', icon: Database, path: '/my-data' },
    { id: 'settings', label: 'Settings', icon: Settings, path: '/settings' }
  ];

  const handleLogout = async () => {
    setIsDropdownOpen(false);
    await onLogout();
    navigate('/');
  };

  return (
    <nav className="app-navbar">
      <div className="app-nav-container">
        {/* Logo/Brand */}
        <Link to="/dashboard" className="app-nav-logo">
          <img src="/PS_logodark.PNG" alt="PointeSense" className="app-logo-image" />
            <span className="app-logo-text">
              <span className="pointe">Pointe</span>
              <span className="sense">Sense</span>
              <span className="pointe">- FIT DEMO</span>
            </span>
        </Link>

        {/* Main Navigation - USE LINK INSTEAD OF BUTTON */}
        <div className="nav-bar">
          <div className="nav-items">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname.startsWith(item.path);
              
              return (
                <Link
                  key={item.id}
                  to={item.path}
                  className={`nav-button ${isActive ? 'active' : ''}`}
                >
                  <Icon size={20} />
                  <span>{item.label}</span>
                </Link>
              );
            })}
          </div>
        </div>

        {/* User Menu */}
        <div className="app-nav-user">
          <div 
            className="user-menu-trigger"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            <div className="user-avatar">
              {currentUser?.username?.[0]?.toUpperCase() || 'U'}
            </div>
            <span className="user-name">{currentUser?.username || 'User'}</span>
            <svg className="dropdown-icon" width="12" height="12" viewBox="0 0 12 12">
              <path d="M2 4L6 8L10 4" stroke="currentColor" strokeWidth="2" fill="none"/>
            </svg>
          </div>

          {isDropdownOpen && (
            <>
              {/* Backdrop to close dropdown when clicking outside */}
              <div 
                className="dropdown-backdrop"
                onClick={() => setIsDropdownOpen(false)}
              />
              <div className="user-dropdown">
                <div className="dropdown-header">
                  <div className="user-email">{currentUser?.email}</div>
                </div>
                <div className="dropdown-divider"></div>
                <a 
                  href="https://pointesense.com" 
                  className="dropdown-item"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                  Back to Website
                </a>
                <button onClick={handleLogout} className="dropdown-item logout">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                  Logout
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;